export class RegisterClientDto {
    clientId: string;
    unsubTopics: boolean;
}
